(function () {
  const STOREFRONT_TOKEN = '1b60da88a5c98619563595b8407607cb';
  const SHOP_DOMAIN = window.Shopify.shop;
  const API_URL = `https://${SHOP_DOMAIN}/api/2024-01/graphql.json`;
  const BATCH_SIZE = 40;

  // Build aliased query for a batch of variant IDs
  function buildBatchQuery(variantIds) {
    const aliases = variantIds.map((id, i) => `
      v${i}: node(id: "gid://shopify/ProductVariant/${id}") {
        ... on ProductVariant {
          id
          storeAvailability(first: 20) {
            edges {
              node {
                quantityAvailable
                location {
                  name
                  metafield(namespace: "custom", key: "storefront_role") {
                    value
                  }
                }
              }
            }
          }
        }
      }
    `).join('\n');
    return `query { ${aliases} }`;
  }

  async function fetchBatch(variantIds) {
    const res = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query: buildBatchQuery(variantIds) })
    });
    const data = await res.json();
    return data?.data || {};
  }

  function patchInventory(batchResult) {
    for (const key of Object.keys(batchResult)) {
      const node = batchResult[key];
      if (!node) continue;

      // Extract numeric ID from GID
      const numericId = parseInt(node.id.split('/').pop());
      const match = window.KoiVariantData.find(v => v.id === numericId);
      if (!match) continue;

      const inventory = {};
      for (const { node: loc } of node.storeAvailability.edges) {
        const role = loc.location?.metafield?.value || 'Hidden';
        if (role === 'Hidden') continue;
        inventory[loc.location.name] = {
          quantity: loc.quantityAvailable,
          role: role
        };
      }
      match.inventory = inventory;
      match.inventoryLoaded = true;
    }
  }

  function updateATCButton() {
    const variantId = parseInt(document.querySelector('input[name="id"]')?.value);
    if (!variantId) return;

    const variant = window.KoiVariantData.find(v => v.id === variantId);
    if (!variant) return;

    const btn = document.getElementById('product-add-to-cart');
    if (!btn) return;

    const locations = Object.values(variant.inventory || {});
    const shipAvailable = locations.some(l => l.role === 'Online' && l.quantity > 0);
    const instoreAvailable = locations.some(l => l.role === 'Physical' && l.quantity > 0);

    if (!shipAvailable && instoreAvailable) {
      btn.textContent = 'Available In-Store Only';
      btn.disabled = true;
    } else if (shipAvailable) {
      btn.disabled = false;
      btn.textContent = window.theme?.strings?.addToCart || 'Add to Cart';
    } else {
      btn.disabled = true;
      btn.textContent = 'Sold out';
    }
  }

  async function init() {
    if (!window.KoiVariantData?.length) return;

    const allIds = window.KoiVariantData.map(v => v.id);

    // Split into batches of 40
    const batches = [];
    for (let i = 0; i < allIds.length; i += BATCH_SIZE) {
      batches.push(allIds.slice(i, i + BATCH_SIZE));
    }

    // Fetch all batches in parallel
    const results = await Promise.all(batches.map(fetchBatch));

    // Patch inventory into KoiVariantData
    results.forEach(patchInventory);

    // Fire ready event
    document.dispatchEvent(new CustomEvent('koi:inventory:ready'));

    // Update ATC for currently selected variant
    updateATCButton();
  }

  // Re-run ATC update on variant change (reads from cache, no new fetch)
  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput) {
    new MutationObserver(() => updateATCButton())
      .observe(variantInput, { attributes: true, attributeFilter: ['value'] });
  }

  init();
})();
